export default __webpack_public_path__ + "static/media/483.ba60530c.jpg";